import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Suspense } from 'preact/compat';
import { useTranslation } from 'react-i18next';
import { Await, Link, useParams } from 'react-router';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@etchteam/diamond-ui/canvas/Card/Card';
import '@/components/canvas/LoadingCard/LoadingCard';
import '@/components/content/Container/Container';
import RateThisInfo from '@/components/control/RateThisInfo/RateThisInfo';
import SchemeContainerSummary from '@/components/template/SchemeContainerSummary/SchemeContainerSummary';
import sortPropertyTypes from '@/lib/sortPropertyTypes';
import { useHomeRecyclingLoaderData } from './home.loader';
function Loading() {
    return (_jsx("diamond-enter", { type: "fade-in-up", children: _jsx("locator-loading-card", {}) }));
}
function PropertyList({ localAuthority, }) {
    const { postcode } = useParams();
    const properties = sortPropertyTypes(localAuthority.properties);
    const propertyTypes = Object.keys(properties);
    return (_jsxs("diamond-enter", { type: "fade", children: [propertyTypes.map((propertyType) => {
                const safePropertyType = encodeURIComponent(propertyType);
                const property = properties[propertyType];
                const containers = property.flatMap((scheme) => scheme.containers);
                return (_jsx(Link, { to: `/${postcode}/home/collection?propertyType=${safePropertyType}`, children: _jsxs("diamond-card", { className: "diamond-spacing-bottom-md", border: true, radius: true, children: [_jsx("h4", { className: "diamond-spacing-bottom-md", children: propertyType }), _jsx(SchemeContainerSummary, { containers: containers, limit: 3 })] }) }, safePropertyType));
            }), _jsx(RateThisInfo, {})] }));
}
export default function HomeRecyclingPage() {
    const { t } = useTranslation();
    const { localAuthority } = useHomeRecyclingLoaderData();
    return (_jsxs("section", { className: "diamond-spacing-bottom-lg", children: [_jsx("h3", { children: t('homeRecycling.collections.title') }), _jsx("p", { children: t('homeRecycling.collections.help') }), _jsx(Suspense, { fallback: _jsx(Loading, {}), children: _jsx(Await, { resolve: localAuthority, children: (la) => _jsx(PropertyList, { localAuthority: la }) }) })] }));
}
